import { render, staticRenderFns } from "./PermohonanSektorChart.vue?vue&type=template&id=3bd0e13c&"
import script from "./PermohonanSektorChart.vue?vue&type=script&lang=js&"
export * from "./PermohonanSektorChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports